import { CatchBoundary, createFileRoute, Outlet } from '@tanstack/react-router';
import { useAppConfiguration } from '@mews-commander/data-access';
import { Z_INDEX_ALERTS } from '@mews-commander/modules';
import { AuthorizationLayout } from '@mews-commander/modules/src/modules/auth';
import { ErrorHandler } from '@mews-commander/ui';
import { MewsTeam, PlatformEnvironment, RouteType } from '@mews/enums';
import { AlertsProvider, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const PublicLayout = () => {
    const { environment } = useAppConfiguration();
    const showStackTrace = environment !== PlatformEnvironment.Production && environment !== PlatformEnvironment.Demo;

    return (
        <AlertsProvider zIndex={Z_INDEX_ALERTS}>
            <AuthorizationLayout>
                <CatchBoundary
                    getResetKey={() => 'resetPublicRoute'}
                    errorComponent={({ error, reset }) => (
                        <ErrorHandler
                            stackTrace={showStackTrace ? error.stack : undefined}
                            errorMessage={<LocalizedText textKey={TextKey.GenericErrorMessage} />}
                            errorTitle={<LocalizedText textKey={TextKey.GenericErrorTitle} />}
                            onDismiss={reset}
                        />
                    )}
                >
                    <Outlet />
                </CatchBoundary>
            </AuthorizationLayout>
        </AlertsProvider>
    );
};

export const Route = createFileRoute('/_public')({
    component: PublicLayout,
    staticData: {
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
